import { IMockAllCapabilitiesForUserTable } from 'mocks/types/mockDbTables';
import { faker } from '@faker-js/faker';
import { UserCapabilityName } from 'types/userCapabilityName';
import { ISelf } from 'types/types.generated';

export const generateAllCapabilitiesForUser = (
  currentSelf: ISelf
): IMockAllCapabilitiesForUserTable[] => {
  const allUserCapabilities: UserCapabilityName[] = [];

  const mockFeatureToggleViewer = sessionStorage.getItem(
    'mockFeatureToggleViewer'
  );
  if (mockFeatureToggleViewer === 'true' || mockFeatureToggleViewer === null) {
    allUserCapabilities.push(UserCapabilityName.FeatureToggleViewer);
  }

  const mockFeatureToggleAdmin = sessionStorage.getItem(
    'mockFeatureToggleAdmin'
  );
  if (mockFeatureToggleAdmin === 'true' || mockFeatureToggleAdmin === null) {
    allUserCapabilities.push(UserCapabilityName.FeatureToggleAdmin);
  }

  return allUserCapabilities.map((val) => ({
    userId: currentSelf.id,
    capabilityId: faker.string.uuid(),
    capabilityName: val,
  }));
};
